import CloseIcon from '@mui/icons-material/Close';

/**
 * TitleBar actions factory.
 * Each action injects its handler via onXxx — no logic lives here, only wiring.
 * Rule: every feature (close, minimize, pin, ...) injects its own onXxx callback.
 *
 * NOTE: This is a deviation on Development.Patterns rk=e265293c (geen logica injecteren).
 * That pattern forbids passing onX mutation props into components.
 * Exception justified here: factory method requires logic injection by design —
 * actions are wired at construction time, not passed down through the render tree.
 *
 * @param {function} onClose - injected from FloatingContentPanel.handleClose
 */
export const TITLE_BAR_ACTIONS = (onClose) => [
    //
    { icon: <CloseIcon sx={{ fontSize: 16 }} />, title: 'Close', onClick: onClose },
];
